import React, { PureComponent } from 'react';

import componentStyles from './TermsAndPrivacy.scss';

class TermsAndPrivacy extends PureComponent {
  render() {
    return (
      <p className={componentStyles.termsAndServices}>
        By continuing, you agree to the{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.quartermaster.house/terms-of-service"
        >
          Terms of Service
        </a>{' '}
        &{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.quartermaster.house/privacy-policy"
        >
          Privacy Policy
        </a>
      </p>
    );
  }
}

export default TermsAndPrivacy;
